module.exports = __webpack_public_path__ + "media/smw_stomp_no_damage.f0ed2462.ogg";